import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@fluentui/react-components';
const MAP = {
    draft: { label: 'Draft', appearance: 'tint', color: 'subtle' },
    sent: { label: 'Sent', appearance: 'tint', color: 'informative' },
    viewed: { label: 'Viewed', appearance: 'tint', color: 'warning' },
    partially_signed: { label: 'Partly signed', appearance: 'tint', color: 'warning' },
    completed: { label: 'Signed', appearance: 'tint', color: 'success' },
    expired: { label: 'Expired', appearance: 'tint', color: 'danger' },
    cancelled: { label: 'Cancelled', appearance: 'tint', color: 'subtle' },
};
export function StatusBadge({ status }) {
    const cfg = MAP[status] ?? { label: status, appearance: 'tint', color: 'subtle' };
    return _jsx(Badge, { appearance: cfg.appearance, color: cfg.color, size: "small", children: cfg.label });
}
